import React, { useState, useEffect, useRef } from "react";
import "./VideoModal.scss";
import { LeftOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";

function VideoModal({ videoUrl, showVideoModal, setShowVideoModal }) {
    if (!showVideoModal) return null;
  return (
    <Modal
      closable
      styles={{ mask: { background: "rgba(0, 0, 0, 0.65)" } }}
      className="video-modal-web-pinnacle"
      open={showVideoModal}
      onCancel={() => setShowVideoModal(false)}
      footer={false}
    >
        <iframe src={videoUrl} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen frameBorder="0" title="video" className="video-modal-iframe" />
    </Modal>
  );
}

export default VideoModal;
